const iso88597Map = {
    // Accented uppercase
    0x0386: 0xB6, // Ά
    0x0388: 0xB8, // Έ
    0x0389: 0xB9, // Ή
    0x038A: 0xBA, // Ί
    0x038C: 0xBC, // Ό
    0x038E: 0xBE, // Ύ
    0x038F: 0xBF, // Ώ

    // Tonos / dialytika
    0x0384: 0xB4, // ΄
    0x0385: 0xB5, // ΅

    // Uppercase Greek
    0x0391: 0xC1, // Α
    0x0392: 0xC2, // Β
    0x0393: 0xC3, // Γ
    0x0394: 0xC4, // Δ
    0x0395: 0xC5, // Ε
    0x0396: 0xC6, // Ζ
    0x0397: 0xC7, // Η
    0x0398: 0xC8, // Θ
    0x0399: 0xC9, // Ι
    0x039A: 0xCA, // Κ
    0x039B: 0xCB, // Λ
    0x039C: 0xCC, // Μ
    0x039D: 0xCD, // Ν
    0x039E: 0xCE, // Ξ
    0x039F: 0xCF, // Ο
    0x03A0: 0xD0, // Π
    0x03A1: 0xD1, // Ρ
    0x03A3: 0xD3, // Σ
    0x03A4: 0xD4, // Τ
    0x03A5: 0xD5, // Υ
    0x03A6: 0xD6, // Φ
    0x03A7: 0xD7, // Χ
    0x03A8: 0xD8, // Ψ
    0x03A9: 0xD9, // Ω

    // Lowercase Greek
    0x03B1: 0xE1, // α
    0x03B2: 0xE2, // β
    0x03B3: 0xE3, // γ
    0x03B4: 0xE4, // δ
    0x03B5: 0xE5, // ε
    0x03B6: 0xE6, // ζ
    0x03B7: 0xE7, // η
    0x03B8: 0xE8, // θ
    0x03B9: 0xE9, // ι
    0x03BA: 0xEA, // κ
    0x03BB: 0xEB, // λ
    0x03BC: 0xEC, // μ
    0x03BD: 0xED, // ν
    0x03BE: 0xEE, // ξ
    0x03BF: 0xEF, // ο
    0x03C0: 0xF0, // π
    0x03C1: 0xF1, // ρ
    0x03C2: 0xF2, // ς (final sigma)
    0x03C3: 0xF3, // σ
    0x03C4: 0xF4, // τ
    0x03C5: 0xF5, // υ
    0x03C6: 0xF6, // φ
    0x03C7: 0xF7, // χ
    0x03C8: 0xF8, // ψ
    0x03C9: 0xF9, // ω

    // Accented lowercase
    0x03AC: 0xDC, // ά
    0x03AD: 0xDD, // έ
    0x03AE: 0xDE, // ή
    0x03AF: 0xDF, // ί
    0x03CC: 0xFC, // ό
    0x03CD: 0xFD, // ύ
    0x03CE: 0xFE, // ώ

    // Dialytika lowercase
    0x03CA: 0xFA, // ϊ
    0x03CB: 0xFB, // ϋ

    // Misc symbols
    0x00A0: 0xA0, // non-breaking space
    0x00A3: 0xA3, // £
    0x00A6: 0xA6, // broken bar
    0x00A7: 0xA7, // §
    0x00A8: 0xA8, // ¨
    0x00A9: 0xA9, // ©
    0x00AB: 0xAB, // «
    0x00AC: 0xAC, // ¬
    0x00AD: 0xAD, // soft hyphen
    0x00BB: 0xBB, // »
    0x20AC: 0xA4, // €
}

export const encodeISO88597 = (str) => {
    const buffer = new Uint8Array(str.length);
    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i);
        if (code < 0x80) buffer[i] = code;
        else if (iso88597Map[code] !== undefined) buffer[i] = iso88597Map[code];
        else buffer[i] = 63; // '?'
    }
    return buffer;
}